import gql from 'graphql-tag'

export const getLIAs = gql`
  query($paging: PagingQuery, $order: LIAsOrder, $filter: LIAsFilter) {
    getLIAs(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      lias {
        id
        name
        birthday
        memo
        gender
        applied
        files {
          id
          type
        }
        applicant{
          id
          username
          userType
        }
        applicantName
        createdAt
        updatedAt
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getLIAById = gql`
  query($liaId: Int!) {
    getLIAById(
      liaId: $liaId
    ) {
      id
      name
      birthday
      memo
      gender
      applied
      phone
      countryCode
      countryCallingCode
      extensionNumber
      applicantName
      files {
        id
        name
        notes
        size
        type
        opinion
        approvalStatus
        financialType
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`

export const newLIA = gql`
  mutation($liaInput: LIAInput!) {
    newLIA(
      liaInput: $liaInput
    ) {
      id
      name
      birthday
      memo
      gender
      applied
      applicant{
        id
        username
        userType
      }
      applicantName
      createdAt
      updatedAt
    }
  }
`

export const deleteLIAFile = gql`
  mutation($fileId: Int!) {
    deleteLIAFile(
      fileId: $fileId
    )
  }
`

export const estimateLIAFile = gql`
  mutation($fileId: Int!, $status: Boolean!) {
    estimateLIAFile(
      fileId: $fileId,
      status: $status
    )
  }
`

export const addLIAFileOpinion = gql`
  mutation($fileId: Int!, $opinion: String) {
    addLIAFileOpinion(
      fileId: $fileId,
      opinion: $opinion
    )
  }
`

export const editLIA = gql`
  mutation($liaId: Int!, $liaInput: LIAInput!) {
    editLIA(
      liaId: $liaId,
      liaInput: $liaInput
    ) {
      id
      name
      birthday
      memo
      gender
      applied
      phone
      countryCode
      countryCallingCode
      extensionNumber
      applicantName
      createdAt
      updatedAt
    }
  }
`

export const deleteLIAById = gql`
  mutation($liaId: Int!) {
    deleteLIAById(
      liaId: $liaId
    )
  }
`

export const applyLIA = gql`
  mutation($liaId: Int!) {
    applyLIA(
      liaId: $liaId
    )
  }
`

export const withdrawLIA = gql`
  mutation($liaId: Int!) {
    withdrawLIA(
      liaId: $liaId
    )
  }
`
